export const OPEN: string = 'rt:modal_open';
export const CLOSE: string = 'rt:modal_close';
